import { InventoryItemButton } from '../InventoryItemButton';

import { InventoryItemRecord } from '~/modules/trade/types/load';

type MaterialItemButtonProps = {
  inventoryItem: InventoryItemRecord;
  onPress: () => void;
  isSelected?: boolean;
};

const MaterialItemButton = ({
  inventoryItem,
  onPress,
  isSelected = false,
}: MaterialItemButtonProps) => (
  <InventoryItemButton
    isSelected={isSelected}
    inventoryItem={inventoryItem}
    onPress={onPress}
    leftElement={inventoryItem.mnemonic}
    align="left"
    variant="subtle"
    overrideGroupStyle
    className="@MaterialItemButton"
  />
);

export type InventoryItemsModalItemsGridProps = {
  items: InventoryItemRecord[];
  selectedId?: string | null;
  onSelectItem: (itemId: string) => void;
};

export const InventoryItemsModalItemsGrid = ({
  items,
  selectedId,
  onSelectItem,
}: InventoryItemsModalItemsGridProps) => (
  <div className="@InventoryItemsModalItemsGrid grid grid-cols-3 gap-2">
    {items.map((item) => (
      <MaterialItemButton
        key={item.id}
        inventoryItem={item}
        isSelected={item.id === selectedId}
        onPress={() => onSelectItem(item.id)}
      />
    ))}
  </div>
);
